export default __webpack_public_path__ + "static/uniminutoLogo-0673d5d67f73d3577a62679ec947a222.png";